import { downloadSafetyPpeIssuanceAttachment } from '../../../api/safety';
import { parseSafetyPpeItems, SafetyPpeIssuance } from '../../../types/safety';
import ApprovalStampBox from '../ApprovalStampBox';
import SignaturePadField from '../../common/SignaturePadField';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../quality/CleanActivityPanel.css';
import '../../quality/SmallGroupPanel.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: SafetyPpeIssuance;
}

function SafetyPpePreviewView({ detail }: Props) {
  const items = parseSafetyPpeItems(detail.itemsJson);

  return (
    <div className="sg-panel">
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>안전장비 지급현황</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            문서번호
            <input readOnly value={detail.docNo || '-'} />
          </label>
          <label>
            연도 *
            <input readOnly value={detail.planYear != null ? String(detail.planYear) : ''} />
          </label>
          <label className="is-span-2">
            제목 *
            <input readOnly value={detail.title || ''} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={3} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="ca-section-head">
          <h3>지급 항목</h3>
        </div>
        <div className="ca-items">
          {items.map((item, idx) => (
            <div className="ca-item-card" key={item.id}>
              <div className="ca-item-card__head">
                <strong>항목 {idx + 1}</strong>
              </div>
              <div className="ca-item-card__grid">
                <label className="is-wide">
                  장비명
                  <input readOnly value={item.equipmentName || ''} />
                </label>
                <label>
                  수량
                  <input readOnly value={item.qty || ''} />
                </label>
                <label>
                  지급일
                  <input readOnly value={item.issueDate || ''} />
                </label>
                <label>
                  부서
                  <input readOnly value={item.departmentName || ''} />
                </label>
                <label>
                  수령자
                  <input readOnly value={item.employeeName || ''} />
                </label>
                <label className="is-full">
                  비고
                  <textarea rows={2} readOnly value={item.remark || ''} />
                </label>
                <div className="is-full">
                  <SignaturePadField value={item.signatureData} disabled />
                </div>
              </div>
            </div>
          ))}
          {items.length === 0 ? (
            <p className="quality-form__hint">등록된 지급 항목이 없습니다.</p>
          ) : null}
        </div>
      </section>

      <section className="quality-form__section">
        <h3 style={{ margin: '0 0 8px' }}>첨부파일</h3>
        <p className="quality-form__hint">관련 파일을 첨부할 수 있습니다.</p>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadSafetyPpeIssuanceAttachment(
              detail.issuanceId,
              file.attachmentId,
              file.fileName
            );
          }}
        />
      </section>
    </div>
    </div>
  );
}

export default SafetyPpePreviewView;
